"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContainer = exports.HeaderWrapper = exports.Wrapper = exports.HelperText = exports.Label = exports.InputWrapper = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.InputWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  width: 100%;
`;
exports.Label = styled_components_1.default.label `
  font-size: 16px;
  font-weight: bold;
`;
exports.HelperText = styled_components_1.default.p `
  font-size: 14px;
  font-weight: bold;
  margin: 4px 0px 0px 0px;
  word-break: normal;
  color: ${colors_1.GREY3};
  color: ${({ $hasWarning }) => $hasWarning && colors_1.YELLOW};
  color: ${({ $hasError }) => $hasError && colors_1.RED};
`;
exports.Wrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.HeaderWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;

  ${({ $isDisabled }) => $isDisabled &&
    (0, styled_components_1.css) `
      color: ${colors_1.GREY2} !important;
      label {
        color: currentColor !important;
      }
  `}
`;
exports.IconContainer = styled_components_1.default.div `
  margin-left: 8px;
  @media screen and (max-width: 688px) {
    display: none;
  }
`;
//# sourceMappingURL=InputField.styles.js.map